var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      (_vm.isLoading && !_vm.isHelpHubHost) || _vm.isCallback
        ? _c("loading-overlay")
        : _vm._e(),
      _vm._v(" "),
      _vm.routeMeta && _vm.routeMeta.displayHeader && !_vm.isHelpHubHost
        ? _c("help-hub-header", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showValidation,
                expression: "showValidation"
              }
            ],
            ref: "header",
            attrs: {
              env: _vm.appEnv,
              "hide-search": _vm.routeMeta.hideSearch,
              title: _vm.routeMeta.title
            },
            on: {
              onHHComponentSuccess: _vm.onHHComponentSuccess,
              onHHComponentError: _vm.onHHComponentError,
              onUserCountryUpdated: _vm.onUserCountryUpdated
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.routeMeta.displayHeader && !_vm.isHelpHubHost
        ? _c(
            "div",
            [
              _c(
                "transition",
                { attrs: { name: _vm.validateTransition, mode: "out-in" } },
                [_vm.authResponse ? _c("router-view") : _vm._e()],
                1
              )
            ],
            1
          )
        : !_vm.isHelpHubHost
        ? _c(
            "div",
            [
              _c(
                "transition",
                { attrs: { name: "fade", mode: "out-in" } },
                [_c("router-view")],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("modals-container"),
      _vm._v(" "),
      _vm.displayFooter
        ? _c("help-hub-footer", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isLoading && !_vm.isCallback,
                expression: "!isLoading&&!isCallback"
              }
            ],
            ref: "footerWebComponent",
            attrs: {
              env: _vm.appEnv,
              "platform-category": _vm.platformCategory
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 